import { render, staticRenderFns } from "./AddKetinggian.vue?vue&type=template&id=0dc64662&lang=pug&"
import script from "./AddKetinggian.vue?vue&type=script&lang=js&"
export * from "./AddKetinggian.vue?vue&type=script&lang=js&"
import style0 from "./AddKetinggian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports